<template>
    <div class="homes">
        <homeHead :isLoading="isLoading"></homeHead>
        <history message="交易"></history>
        <div class="sto">
            <div class="sto-swipe" style="margin-top: 10px;">
                <van-swipe
                    class="my-swipe"
                    :autoplay="3000"
                    indicator-color="white"
                >
                    <van-swipe-item>
                        <img
                            style="width: 100%; height: 190px"
                            src="./img/hk.jpg"
                        />
                    </van-swipe-item>
                    <van-swipe-item>
                        <img
                            style="width: 100%; height: 190px"
                            src="./img/photo1.jpg"
                        />
                    </van-swipe-item>
                    <van-swipe-item>
                        <img
                            style="width: 100%; height: 190px"
                            src="./img/photo2.jpg"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="sto-tab">
                <div class="sto-tab-li" style="margin-top: 40px;">
                    <transactionUi :data="transactionData" @approve="approveClick"></transactionUi>
                </div>
            </div>
            <div style="height: 60px;"></div>
        </div>
    </div>
</template>

<script>
import homeHead from '../components/homeHead/homeHead'
import history from '../components/historyGo/historyGo.vue'
import transactionUi from "../components/transactionUi/transactionUi.vue"
import BigNumber from "bignumber.js";
export default {
    name: 'Transaction',
    // 组件
    components: {
        homeHead,
        history, 
        transactionUi
    },
    data() {
        return {
            isLoading: false,
            transactionData:{
                userBnb:0,
                imgExchange: require('@/assets/exchange.png'),
                imgBnb:require('@/assets/bnb_icon.png'),
                option:[
                { 
                  // 交易队信息
                  text: 'USDT-HKHX', 
                  value: 0, 
                  // 主币   
                  tite:'USDT',
                  titeCoin:0,
                  imgTite:require('@/assets/usdt_icon.png'),
                  titeApprove:false,

                  // 辅币
                  subtitle:"HKHX",
                  subtitleCoin:0,
                  imgSubtitle:require('@/assets/logo.png'),
                  subtitleApprove:false,
                },
                // { 
                //   // 交易队信息
                //   text: 'BNB-HKXH', 
                //   value: 1, 
                //   // 主币 
                //   tite:'BNB',
                //   titeCoin:100,
                //   imgTite:require('@/assets/bnb_icon.png'),
                //   titeApprove:false,
                //   // 辅币
                //   subtitle:"HKXH",
                //   subtitleCoin:20,
                //   imgSubtitle:require('@/assets/logo.png'),
                //   subtitleApprove:true,
                // },
                ]
            }
        }
    },
    computed: {},
    async created() {
        this.userBnb()
    },
    async mounted(){

    },

    methods: {
        // 授权方法
        approveClick(data){
            if(data.tite=="USDT"){
                // this.transactionData.option[data.optionsInidex].titeApprove = true
            }
        },
        // 获取当前钱包BNB余额
        async userBnb(){
            let bnb = await this.basicWallet.web3.web3.eth.getBalance(this.web3.userAddress);
            this.transactionData.userBnb = await this.basicWallet.precisionDiv(bnb,18,8)
        }
    },
}
</script>
<style>
@import './style/transaction.css'; 
</style>
